import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { FaSave, FaUserAlt } from "react-icons/fa";
import { useUser } from "../../auth/UseUser";
import { Button } from "@mui/material";
import { notif } from "../utils/util";

function Profile() {
  const { user, setUser } = useUser();
  const [firstName, setFirstName] = useState(user?.firstName);
  const [lastName, setLastName] = useState(user?.lastName);
  const [email, setEmail] = useState(user?.email);
  const [password, setPassword] = useState("");

  const saveProfile = () => {
    if (!firstName || !lastName || !email || !password) {
      notif("Profile is saved", "success");
    }
  };
  return (
    <div className="bg-[#0a1929] h-full text-white flex py-5 flex-col  items-center">
      <div className="flex items-center justify-center mt-5 w-[100px] h-[100px] rounded-full bg-gray-500">
        <FaUserAlt className="w-[32px] h-[32px]" />
      </div>
      <div className="w-[400px] mt-10">
        <p className="py-4 text-gray-500">Change first and last name</p>
        <div className="flex items-center justify-center gap-4 ">
          <TextField
            id="firstName"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            label="First Name"
            variant="filled"
            sx={{ input: { color: "white" }, label: { color: "gray" } }}
          />
          <TextField
            id="lastName"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            label="Last Name"
            variant="filled"
            sx={{ input: { color: "white" }, label: { color: "gray" } }}
          />
        </div>
        <p className="pt-6 text-gray-500">Update Email</p>
        <div className="flex items-center justify-center mt-3">
          <TextField
            fullWidth
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            label="Email"
            variant="filled"
            sx={{ input: { color: "white" }, label: { color: "gray" } }}
          />
        </div>{" "}
        <p className="pt-6 text-gray-500">Update Password</p>
        <div className="flex items-center justify-center mt-3">
          <TextField
            fullWidth
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            label="Password"
            variant="filled"
            sx={{ input: { color: "white" }, label: { color: "gray" } }}
          />
        </div>
        <div className="w-full flex justify-end mt-5 items-center">
          <Button
            variant="contained"
            endIcon={<FaSave />}
            onClick={saveProfile}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Profile;
